module.exports = {
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    socketUrl: process.env.REACT_APP_BACKENDS_URL,
    frontendUrl: process.env.REACT_APP_FRONT_URL,
    centerCode: process.env.REACT_APP_CENTERCODE ?? '99999',
    centerPassCode: process.env.REACT_APP_PASSCODE ?? '99999',
  };
